import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * å­¦æ ¡å°å
 */
@JsonObject
export class SchoolAddress {
  /**
   * æå±å¸çº§è¡æ¿åºid
   */
  @JsonProperty('cityId', Number)
  cityId: number = undefined;

  /**
   * æå±å¿çº§è¡æ¿åºid
   */
  @JsonProperty('countyId', Number)
  countyId: number = undefined;

  /**
   * æå±ççº§è¡æ¿åºid
   */
  @JsonProperty('provinceId', Number)
  provinceId: number = undefined;

  /**
   * å·ä½å°å
   */
  @JsonProperty('detail', String)
  detail: string = undefined;
}
